import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ModulesService } from '../modules.service';
import { Module } from '../module';
import { Observable } from 'rxjs';

@Component({
    selector: 'app-modules',
    templateUrl: './modules.component.html',
    styleUrls: ['./modules.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class ModulesComponent implements OnInit {
  modules: Module[] | undefined;
  dataSource: Observable<Module[]> | undefined;
  displayedColumns: string[] = ['moduleId', 'name', 'description'];

  constructor(private modulesService: ModulesService) {
  }

  ngOnInit(): void {
    this.dataSource = this.modulesService.getModules();
    this.dataSource.subscribe(modules => {
      this.modules = modules;
      //console.log(this.modules);
    });
  }
}
